class BundleButton extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector("bundle-products-form");
    this.addEventListener("click", this.buttonClicked.bind(this));
  }

  buttonClicked() {
    fetch(`${this.dataset.url}?sections=bundle-builder`)
      .then((response) => response.json())
      .then(this.handleResponse.bind(this))
      .catch(console.error);
  }

  handleResponse(response) {
    const targetElement = document.querySelector(".bundle-product-item:empty");
    if (targetElement) {
      targetElement.innerHTML = response["bundle-builder"];
    }
    const bundles = document.querySelectorAll(
      ".bundle-product-item:not(:empty)"
    );

    document.querySelector(".js-current-item").innerHTML =
      document.querySelectorAll(".bundle-product-item:not(:empty)").length;
    var productSticky = document.querySelector(".product-sticky");
    var body = document.body;

    if (bundles.length >= 3) {
      this.form.removeAttribute("disabled");
      this.updatePrices(bundles);
      productSticky.classList.add("active");
      if (productSticky.classList.contains("active")) {
        body.classList.add("mobile-scroll");
      } else {
        body.classList.remove("mobile-scroll");
      }

      document.querySelectorAll("bundle-add-buttons").forEach((button) => {
        button.setAttribute("disabled", "");
      });

      const radioButtons = this.form.querySelectorAll(
        'input[name="bundle-selling-plan"]'
      );
      radioButtons.forEach((radio) => {
        radio.addEventListener("change", function () {
          if (this.checked) {
            console.log(this, "thiss");
            if (this.classList.contains("subscription")) {
              document
                .querySelectorAll('input[name="bundle_selling_plan"]')
                .forEach((sellOption) => {
                  sellOption.removeAttribute("disabled");
                });
            } else {
              document
                .querySelectorAll('input[name="bundle_selling_plan"]')
                .forEach((sellOption) => {
                  sellOption.setAttribute("disabled", "");
                });
            }
          }
        });
      });
    } else {
      this.form.setAttribute("disabled", "");
      document.querySelectorAll("bundle-add-buttons").forEach((button) => {
        button.removeAttribute("disabled");
      });
      this.updatePriceElement(".js-single-option-price", 0, 0);
      this.updatePriceElement(".js-selling-plan-price", 0, 0);
    }
  }

  updatePrices(bundles) {
    let [
      originalPrice,
      comparePrice,
      purchaseOriginalPrice,
      purchaseComparePrice,
      single_percentage,
      purchase_percentage,
    ] = [0, 0, 0, 0];

    bundles.forEach((bundle) => {
      const singleOption = bundle.querySelector(".single-option").dataset;
      const purchaseOptions = bundle.querySelector(".purchase-options").dataset;

      originalPrice += parseInt(singleOption.price);
      comparePrice += parseInt(singleOption.compareprice);
      purchaseOriginalPrice += parseInt(purchaseOptions.sell_price);
      purchaseComparePrice += parseInt(purchaseOptions.sell_compareprice);
    });

    single_percentage = (((comparePrice - originalPrice) / comparePrice) * 100).toFixed(0);

    purchase_percentage =
      (((purchaseComparePrice - purchaseOriginalPrice) / purchaseComparePrice) *
      100).toFixed(0);

    single_percentage > 0
      ? (this.form.querySelector(
          "label.bundle-selling-plan.single-plan .save-label"
        ).innerHTML = "Save" + single_percentage + "%")
      : "";
    purchase_percentage > 0
      ? (this.form.querySelector(
          "label.bundle-selling-plan.purchase-plan .save-label"
        ).innerHTML = "Save" + purchase_percentage + "%")
      : "";

    // Apply 20% discount to originalPrice
    const discountedOriginalPrice = originalPrice;

    // Apply 30% discount to purchaseOriginalPrice
    const discountedPurchaseOriginalPrice = purchaseOriginalPrice;

    this.updatePriceElement(
      ".js-single-option-price",
      discountedOriginalPrice,
      comparePrice
    );
    this.updatePriceElement(
      ".js-selling-plan-price",
      discountedPurchaseOriginalPrice,
      purchaseComparePrice
    );
  }

  updatePriceElement(selector, originalPrice, comparePrice) {
    const element = this.form.querySelector(selector);
  
    // Check if the original price exists
    if (originalPrice) {
      element.querySelector(".original-price").innerHTML = this.formatMoney(originalPrice);
      element.querySelector(".original-price").style.display = ""; // Ensure it's visible
    } else {
      element.querySelector(".original-price").innerHTML = "";
      element.querySelector(".original-price").style.display = "none"; // Hide if not available
    }
  
    // Check if the compare price exists
    const comparePriceElement = element.querySelector(".compare-price");
    if (comparePrice && comparePrice > originalPrice) {
      comparePriceElement.innerHTML = this.formatMoney(comparePrice);
      comparePriceElement.style.display = ""; // Ensure it's visible
    } else {
      comparePriceElement.innerHTML = "";
      comparePriceElement.style.display = "none"; // Hide if not available or invalid
    }

  }
  

  formatMoney(amount) {
    return theme.Currency.formatMoney(
      amount,
      window.shopSettings.moneyFormat.replace("amount", "amount_no_decimals")
    );
  }
}

class BundleButtonRemove extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector("bundle-products-form");
    this.addEventListener("click", this.bundleRemoved.bind(this));
  }

  bundleRemoved() {
    this.closest(".bundle-product-item")
      .querySelector("#shopify-section-bundle-builder")
      .remove();
    document.querySelector(".js-current-item").innerHTML =
      document.querySelectorAll(".bundle-product-item:not(:empty)").length;
    this.form.setAttribute("disabled", "");
    document.querySelectorAll("bundle-add-buttons").forEach((button) => {
      button.removeAttribute("disabled");
    });

    this.updatePriceElement(".js-single-option-price", 0, 0);
    this.updatePriceElement(".js-selling-plan-price", 0, 0);

    this.form.querySelector(
      "label.bundle-selling-plan.single-plan .save-label"
    ).innerHTML = "";
    this.form.querySelector(
      "label.bundle-selling-plan.purchase-plan .save-label"
    ).innerHTML = "";
  }

  updatePriceElement(selector, originalPrice, comparePrice) {
    const element = this.form.querySelector(selector);
    element.querySelector(".original-price").innerHTML = originalPrice
      ? this.formatMoney(originalPrice)
      : "";
    element.querySelector(".compare-price").innerHTML = comparePrice
      ? this.formatMoney(comparePrice)
      : "";
  }
}

class BundleCard extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector("mini-cart");
    this.querySelector(".product-bundle-form__submit").addEventListener(
      "click",
      this.addButtonClick.bind(this)
    );
  }

  addButtonClick() {
    const isSubscription = this.querySelector(
      ".product-forms .bundle-subscriptions:checked"
    );

    const bundleSelling = this.querySelector(
      '[name="bundle_selling_plan"]:checked'
    ).dataset.optionName;

    const selectedDataName = bundleSelling;
    const uniqueNumber = Date.now();

    const items = Array.from(
      document.querySelectorAll(".bundle-product-item:not(:empty)")
    )
      .map((bundle) =>
        this.createItemObject(
          bundle,
          selectedDataName,
          isSubscription,
          uniqueNumber
        )
      )
      .reduce((acc, item) => {
        const existingItem = acc.find((i) => i.id === item.id);
        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          acc.push({ ...item, quantity: 1 });
        }
        return acc;
      }, []);

    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      items,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_add_url}`, {
      ...fetchConfig("javascript"),
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === 422) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error", {
              detail: {
                errorMessage: response.description,
              },
            })
          );
        } else {
          fetch(`${window.routes.cart_url}.js`)
            .then((response) => response.json())
            .then((cartData) => {
              const free_gift = window.min_gift.free_git;
              const minPrice = window.min_gift.min_price;
              const isGiftAdded = cartData.items.some(
                (item) => item.id == free_gift
              );
              if (cartData.total_price > minPrice && free_gift != 0) {
                if (!isGiftAdded) {
                  var items = [
                    {
                      quantity: 1,
                      id: parseInt(free_gift),
                      properties: {
                        _min_gift_product: true,
                      },
                    },
                  ];
                  // console.log(items, 'items')
                  fetch(`${window.routes.cart_add_url}.js`, {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                    },
                    body: JSON.stringify({
                      items,
                      sections: sections,
                      sections_url: window.location.pathname,
                    }),
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      // console.log(response, 'response')
                      this.miniCart && this.miniCart.renderContents(response);
                      document.dispatchEvent(
                        new CustomEvent("ajaxProduct:added", {
                          detail: {
                            product: response,
                          },
                        })
                      );
                    });
                } else {
                  var cartPrice = cartData.total_price;
                  if (cartPrice < minPrice && free_gift != 0) {
                    const giftItem = cartData.items.filter(
                      (item) => item.properties?._min_gift_product == true
                    );
                    if (giftItem.length) {
                      fetch(`${window.routes.cart_change_url}.js`, {
                        method: "POST",
                        credentials: "same-origin",
                        headers: {
                          "Content-Type": "application/json",
                          "X-Requested-With":
                            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                        },
                        body: JSON.stringify({
                          id: giftItem[0].key,
                          quantity: 0,
                          sections: sections,
                          sections_url: window.location.pathname,
                        }),
                      })
                        .then((response) => response.json())
                        .then((response) => {
                          //  console.log(response, 'response')
                          this.miniCart &&
                            this.miniCart.renderContents(response);
                          document.dispatchEvent(
                            new CustomEvent("ajaxProduct:added", {
                              detail: {
                                product: response,
                              },
                            })
                          );
                        });
                    }
                  } else {
                    this.miniCart && this.miniCart.renderContents(response);
                    document.dispatchEvent(
                      new CustomEvent("ajaxProduct:added", {
                        detail: {
                          product: response,
                        },
                      })
                    );
                  }
                }
              } else {
                const giftItem = cartData.items.filter(
                  (item) => item.properties?._min_gift_product == true
                );
                if (giftItem.length) {
                  fetch(`${window.routes.cart_change_url}.js`, {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                    },
                    body: JSON.stringify({
                      id: giftItem[0].key,
                      quantity: 0,
                      sections: sections,
                      sections_url: window.location.pathname,
                    }),
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      // console.log(response, 'response')
                      this.miniCart && this.miniCart.renderContents(response);
                      document.dispatchEvent(
                        new CustomEvent("ajaxProduct:added", {
                          detail: {
                            product: response,
                          },
                        })
                      );
                    });
                } else {
                  this.miniCart && this.miniCart.renderContents(response);
                  document.dispatchEvent(
                    new CustomEvent("ajaxProduct:added", {
                      detail: {
                        product: response,
                      },
                    })
                  );
                }
              }
            });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  createItemObject(bundle, selectedDataName, isSubscription, uniqueNumber) {
    const selectElement = bundle.querySelector('select[name="selling_plan"]');
    const targetOption = Array.from(selectElement.options).find(
      (option) => option.getAttribute("data-name") === selectedDataName
    );

    const selling_id = targetOption ? targetOption.value : null;

    return {
      id: bundle.querySelector('[name="id"]').value,
      quantity: 1,
      selling_plan: selling_id && isSubscription ? selling_id : "",
      properties: {
        _custom_bundle: "1",
        _cb_number: uniqueNumber,
      },
    };
  }
}

customElements.define("bundle-add-buttons", BundleButton);
customElements.define("remove-bundle-button", BundleButtonRemove);
customElements.define("product-bundle-card", BundleCard);

document.addEventListener("DOMContentLoaded", function () {
  var toggleButton = document.getElementById("Toggle Bundle Builder form");
  var productSticky = document.querySelector(".product-sticky");
  var body = document.body;

  toggleButton.addEventListener("click", function () {
    if (window.innerWidth <= 768) {
      productSticky.classList.toggle("active");
      if (productSticky.classList.contains("active")) {
        body.classList.add("mobile-scroll");
      } else {
        body.classList.remove("mobile-scroll");
      }
    }
  });
});
